import {IController} from "angular";
import * as angular from "angular";

export class planningRoutesTotalsBarCtrl implements IController {
  totals: any;

  public isMobileView: any;

  constructor(private $mdMedia) {
  }

  $onInit() {

  };

  $doCheck() {
    this.isMobileView = !this.$mdMedia('gt-xs');
  };


}


angular
  .module('bringoz.admin.lean-planning')
  .component('planningRoutesTotalsBar', {
    bindings: {
      totals: '<'
    },
    template: require('./planning-routes-totals-bar.html').default,
    controller: planningRoutesTotalsBarCtrl
  });
